<template>
  <div>
    <div class="section-title">订单基本信息</div>
    <el-form :model="form" label-width="200px" class="form-block" size="small">
      <el-row :gutter="24">
        <!-- <el-col :span="12">
          <el-form-item label="购买名称">
            <el-input v-model="form.buyName" disabled />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="报名创建时间">
            <el-input v-model="form.createTime" disabled />
          </el-form-item>
        </el-col> -->

        <el-col :span="12">
          <el-form-item label="活动订单编号">
            <el-input v-model="form.activityOrderNo" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联商品订单编号">
            <el-input v-model="form.relationGoodsOrderNo" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="用户姓名">
            <el-input v-model="form.userName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户手机号">
            <el-input v-model="form.userMobile" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="订单状态">
            <el-input v-model="form.orderStatusText" disabled />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="充电桩安装完成时间">
            <el-input v-model="form.pileInstallCompletedTime" disabled />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="关联主服订单编号">
            <el-input v-model="form.pileInstallOrderNo" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会员服务状态">
            <el-input v-model="form.memberServiceStatusText" disabled />
          </el-form-item>
        </el-col> -->

        <!-- <el-col :span="12">
          <el-form-item label="会员服务累计支付（元）">
            <el-input v-model="form.memberServiceTotalPaid" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会员服务累计使用时长（月）">
            <el-input v-model="form.memberServiceUsedMonths" disabled />
          </el-form-item>
        </el-col> -->

        <!-- <el-col :span="12">
          <el-form-item label="充电桩设备编号">
            <el-input v-model="form.pileDeviceNo" disabled />
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item label="流量服务状态">
            <el-input v-model="form.actualAmountStatusName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备绑定时间">
            <el-input v-model="form.deviceBindTime" disabled />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="充电桩设备资产编号">
            <el-input v-model="form.pileDeviceAssetNo" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="芝麻信用状态">
            <el-input v-model="form.zhimaCreditStatusText" disabled />
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item label="开关设备编号">
            <el-input v-model="form.pileCode" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="开关设备资产编号">
            <el-input v-model="form.pileAssetCode" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="解约类型">
            <el-input v-model="form.refundReasonTypeName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户解约申请时间">
            <el-input v-model="form.cancelRequestTime" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="解约完成时间">
            <el-input v-model="form.terminateCompleteTime" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户解约原因">
            <el-input :value="form.refundCancelReason"  disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="买断类型">
            <el-input v-model="form.buyoutReasonTypeName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="买断完成时间">
            <el-input v-model="form.buyOutCancelFinishTime" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="是否违规买断">
            <el-input :value="getViolationBuyoutText()" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="违规买断原因">
            <el-input v-model="form.refundCancelReason" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="买断免押扣款金额（元）">
            <el-input v-model="form.activityOrderOriginPrice" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否满足补贴发放">
            <el-input :value="form.isEndDisbursement === 1 || form.isEndDisbursement === '1' ? '是' : ''" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="所属代理商">
            <el-input v-model="form.agentName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="代理商账号">
            <el-input v-model="form.agentPhone" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="代理商级别">
            <el-input :value="getAgentLevelText(form.agentLevel)" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="上级代理">
            <el-input v-model="form.parentAgentName" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="省市区">
            <ZD-area-select ref="areaSelect" :key="areaSelectKey" :showLevel="'3'" :selProvince="form.province"
              :selCity="form.city" :selArea="form.area" :disabledFlag="false" @updateSelAreas="updateAreaSelection" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址">
            <el-input v-model="form.detailAddress" placeholder="请输入详细地址" />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import ZDAreaSelect from "@/components/area-select/index.vue";

export default {
  name: "OrderInfo",
  components: {
    ZDAreaSelect,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    areaSelectKey: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    updateAreaSelection(areaData) {
      this.$emit("updateArea", areaData);
    },
    // 获取违规买断显示文本：1显示"是"，0显示"不是"，其他显示空
    getViolationBuyoutText() {
      const value = this.form.isViolationBuyout !== undefined ? this.form.isViolationBuyout : this.form.isViolationBuyoutText;
      if (value === 1 || value === '1') {
        return '是';
      } else if (value === 0 || value === '0') {
        return '否';
      }
      return '';
    },
    getAgentLevelText(level) {
      const map = {
        LEVEL_ONE: "一级",
        LEVEL_TWO: "二级",
        LEVEL_THREE: "三级",
        "1": "一级",
        "2": "二级",
        "3": "三级",
        1: "一级",
        2: "二级",
        3: "三级",
      };
      return map[level] || map[String(level)] || level || "-";
    },
  },
};
</script>

<style lang="less" scoped>
.order-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.order-no {
  color: #409EFF;
  font-weight: 500;
}

.form-block {
  background: #fff;
}
</style>
